// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"31146619","101":"d6981df3","115":"79495e84","141":"0d6d5675","378":"f503630d","453":"d45d1fc3","556":"76c38640","608":"d19d7141","645":"4480e1eb","711":"98c0bff4","793":"d92a14cf","890":"945d70ca"}[chunkId] + ".chunk.js";
};